import type { UsageTotals } from "./useChatTranscript";

interface Props {
  usage: UsageTotals;
}

const fmt = new Intl.NumberFormat("de-DE");

export function TokenCounter({ usage }: Props) {
  const empty = usage.input + usage.output + usage.cacheRead + usage.cacheCreate === 0;
  if (empty) return null;
  return (
    <div className="token-counter" title="Token usage for this session">
      <span className="token-label">Tokens:</span>
      <span className="token-chip" title="Input tokens">In: <b>{fmt.format(usage.input)}</b></span>
      <span className="token-chip" title="Output tokens">Out: <b>{fmt.format(usage.output)}</b></span>
      <span className="token-chip" title="Cache read tokens">Cache ↩: <b>{fmt.format(usage.cacheRead)}</b></span>
      <span className="token-chip" title="Cache creation tokens">Cache +: <b>{fmt.format(usage.cacheCreate)}</b></span>
    </div>
  );
}
